import rehypeMinifyWhitespace from "rehype-minify-whitespace";
import rehypeRaw from "rehype-raw";
import rehypeSanitize from "rehype-sanitize";
import rehypeStringify from "rehype-stringify";
import remarkBreaks from "remark-breaks";
import remarkGfm from "remark-gfm";
import remarkParse from "remark-parse";
import remark2rehype from "remark-rehype";
import { unified } from "unified";
const pipeline = unified()
    .use(remarkParse)
    .use(remarkGfm)
    .use(remarkBreaks)
    .use(remark2rehype, { allowDangerousHtml: true })
    .use(rehypeRaw)
    .use(rehypeSanitize)
    .use(rehypeMinifyWhitespace)
    .use(rehypeStringify);
export const markdownToHtml = pipeline.process.bind(pipeline);
export const markdownToHtmlSync = pipeline.processSync.bind(pipeline);
export const removeFormatter = (markdown) => markdown.replace(/^---(.|\n)*?---/, "");
//# sourceMappingURL=markdownToHtml.js.map